import phoneNumber from 'awesome-phonenumber';

const validateSSN = (ssn: string): boolean => {
  return /^\d{9}$/.test(ssn);
};

const validateEmail = (email: string): boolean => {
  return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
    email
  );
};

const validateFilled = (str: string) => {
  return str.length > 0;
};

const validateDate = (date: string): boolean => {
  const matchesShape = /[0-1][0-9]\/[0-23][0-9]\/[0-9]{4}/.test(date);

  if (matchesShape) {
    const asDate = new Date(date);
    return asDate instanceof Date && !isNaN(asDate.getTime());
  }
  return false;
};

const validatePassword = (pass: string): boolean => {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
    pass
  );
};

const validatePhone = (phone: string): boolean => {
  return new phoneNumber(phone, 'US').isValid();
};

const validateCell = (phone: string): boolean => {
  return new phoneNumber(phone, 'US').isMobile();
};

const validateYear = (str: string): boolean => {
  return /\d{4}/.test(str);
};

const validateZip = (zip: string): boolean => {
  return (
    /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/.test(zip) ||
    /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/.test(zip)
  );
};

const schoolValidator = (school: any): boolean => {
  const fail = () => {
    throw new Error('validation failed');
  };
  try {
    let hasFailed = false;

    hasFailed = validateFilled(school.city) || fail();

    return hasFailed;
  } catch (e) {
    return false;
  }
};

const validators = {
  validateCell,
  validateDate,
  validateEmail,
  validateFilled,
  validatePassword,
  validatePhone,
  validateSSN,
  validateYear,
  validateZip,
};

export const typeValidators = {
  schoolValidator,
};

export const validatorComponent = {
  methods: {
    ...validators,
  },
};

export default validators;
